//import mod from "../tools/modulo"
import { updateSearchBar } from "./search"

const get_highlighted_suggestion = (search_suggestions) => {
    var highlighted_index = null

    search_suggestions.forEach((item, index) => {
        if (item.classList.contains("highlighted")) {
            highlighted_index = index
        }
    })

    return highlighted_index
}
function mod(n, m) {
    return ((n % m) + m) % m;
}

const handleKeyDirection = (operation) => {
        let search_suggestions = document.getElementById("search_suggestions")
        if (search_suggestions.style.display === "block") {
            const suggestions = search_suggestions.querySelectorAll(".search-suggestion");
            let highlighted_index = get_highlighted_suggestion(suggestions);

            if (highlighted_index !== null) {
                suggestions[highlighted_index].classList.remove("highlighted");
                const nextIndex = mod(operation(highlighted_index), suggestions.length);
                suggestions[nextIndex].classList.add("highlighted");
                suggestions[nextIndex].scrollIntoView({ block: "nearest" });
            } else {
                suggestions[0].classList.add("highlighted");
                suggestions[0].scrollIntoView({ block: "nearest" });
            }
        }
}

export const handleKeyDown = (event) => {
    if (event.key === 'ArrowDown') {
        const nextSuggestion = (val) => {return val+1};
        handleKeyDirection(nextSuggestion);
    }
};

export const handleKeyUp = (event) => {
    if (event.key === 'ArrowUp') {
        const prevSuggestion = (val) => {return val-1};
        handleKeyDirection(prevSuggestion);
    }
};

export const handleKeyEnter = (event) => {
    if (event.key === 'Enter') {
        let search_suggestions = document.getElementById("search_suggestions")
        const suggestions = search_suggestions.querySelectorAll(".search-suggestion");
        let highlighted_index = get_highlighted_suggestion(suggestions);
        if (search_suggestions.style.display === "block" && highlighted_index !== null) {
            let newSearchValue = suggestions[highlighted_index].children[1].textContent
            updateSearchBar(newSearchValue)
        } else {
            let search_input = document.getElementById("search_bar_input").value
            if (search_input !== "") {
                let search_button = document.getElementById("search-btn")
                search_button.click()
            }
        }
    }
}